import React, { Component } from 'react'
import moment from 'moment'
import { destroy, get } from './util'
import Panel from './components/Panel'
import Button from './components/Button'
import Modal from './components/Modal'

class Device extends Component {
  state = {
    loading: true,
    devices: [],
    sortColumn: 'user',
    sortDirection: 'asc',
    notice: null,
    remove: null
  }

  componentDidMount () {
    get('admin/devices').then(devices => {
      this.setState({ devices, loading: false })
    })
  }

  onSortChange = column => {
    this.setState(prev => ({
      sortColumn: column,
      sortDirection: prev.sortColumn === column && prev.sortDirection === 'asc' ? 'desc' : 'asc'
    }))
  }

  sortDevices = devices => {
    const { sortColumn, sortDirection } = this.state
    const sortedDevices = [...devices].sort((a, b) => {
      let comparison = 0
      if (sortColumn === 'registerDate' || sortColumn === 'lastOnlineDate') {
        comparison = moment(a[sortColumn]).diff(moment(b[sortColumn]))
      } else {
        comparison = (a[sortColumn] || '').toString().localeCompare((b[sortColumn] || '').toString())
      }
      return sortDirection === 'asc' ? comparison : -comparison
    })
    return sortedDevices
  }

  renderTable () {
    const devices = this.sortDevices(this.state.devices)
    if (!devices.length) {
      return (
        <Panel>
          <div className='text-center'>
            <h3 className='text-lg font-semibold text-ink'>No devices yet</h3>
            <p className='text-sm text-slate-500 mt-2'>Devices will appear here once your team signs in with the enterprise profile.</p>
          </div>
        </Panel>
      )
    }
    const columns = [
      { key: 'deviceName', label: 'Device Name' },
      { key: 'deviceModel', label: 'Model' },
      { key: 'deviceID', label: 'Device ID' },
      { key: 'user', label: 'Owner' },
      { key: 'registerDate', label: 'Register Date' },
      { key: 'lastOnlineDate', label: 'Last Online' },
      { key: 'version', label: 'Client Version' }
    ]
    return (
      <Panel tight>
        <div className='overflow-x-auto'>
          <table className='w-full text-sm'>
            <thead>
              <tr className='text-left text-slate-500 border-b border-slate-100'>
                {columns.map(col => (
                  <th
                    key={col.key}
                    className='px-3 py-2 cursor-pointer select-none'
                    onClick={() => this.onSortChange(col.key)}
                  >
                    <div className='inline-flex items-center gap-1'>
                      {col.label}
                      {this.state.sortColumn === col.key && (
                        <span>{this.state.sortDirection === 'asc' ? '↑' : '↓'}</span>
                      )}
                    </div>
                  </th>
                ))}
                <th className='px-3 py-2' />
              </tr>
            </thead>
            <tbody>
              {devices.map(device => (
                <tr key={device.deviceID} className='border-b border-slate-50 hover:bg-slate-50/50'>
                  <td className='px-3 py-2'>{device.deviceName}</td>
                  <td className='px-3 py-2'>{device.deviceModel}</td>
                  <td className='px-3 py-2'>{device.deviceID}</td>
                  <td className='px-3 py-2'>{device.user}</td>
                  <td className='px-3 py-2'>{moment(device.registerDate).fromNow()}</td>
                  <td className='px-3 py-2'>{moment(device.lastOnlineDate).fromNow()}</td>
                  <td className='px-3 py-2'>{device.version}</td>
                  <td className='px-3 py-2 text-right'>
                    <button
                      className='text-rose-500 hover:text-rose-600 font-semibold'
                      onClick={() => this.setState({ remove: device })}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  render () {
    if (this.state.loading) {
      return <div className='flex items-center justify-center py-20 text-slate-500'>Loading devices…</div>
    }

    return (
      <div className='space-y-4'>
        {this.state.notice && (
          <div className='rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900 flex items-center justify-between'>
            <span>{this.state.notice}</span>
            <button className='text-emerald-700 font-semibold' onClick={() => this.setState({ notice: null })}>Close</button>
          </div>
        )}
        {this.renderTable()}
        <Modal
          open={Boolean(this.state.remove)}
          onClose={() => this.setState({ remove: null })}
          title='Unregister device'
          footer={[
            <Button key='cancel' variant='ghost' onClick={() => this.setState({ remove: null })}>Cancel</Button>,
            <Button
              key='remove'
              variant='primary'
              onClick={() => {
                const { deviceID } = this.state.remove
                destroy(`admin/devices/${deviceID}`)
                  .then(() => {
                    this.setState({
                      remove: null,
                      devices: this.state.devices.filter(device => device.deviceID !== deviceID),
                      notice: 'Device removed'
                    })
                  })
                  .catch(e => {
                    this.setState({ remove: null, notice: `Delete failed: ${e.message}` })
                  })
              }}
            >
              Remove
            </Button>
          ]}
        >
          <p>
            Are you sure you want to unregister{' '}
            <strong>{(this.state.remove && this.state.remove.deviceName) || 'this device'}</strong>? This action cannot be undone.
          </p>
        </Modal>
      </div>
    )
  }
}

export default Device
